import { useQuery, useQueryClient } from "@tanstack/react-query";

import { REACT_QUERY_KEY } from "~/core/constants/common";

import { getOpportunityAttributesByPipelineId } from "../api/queries";

type UseOpportunityAttributesDataByPipelineIdParams = {
  pipeline_id?: string;
  enabled?: boolean;
};

export const useOpportunityAttributesDataByPipelineId = ({
  pipeline_id,
  enabled = true,
}: UseOpportunityAttributesDataByPipelineIdParams) => {
  const {
    data: opportunityAttributes,
    isLoading: loadingOpportunityAttributes,
  } = useQuery({
    queryKey: [REACT_QUERY_KEY.OPPORTUNITY_ATTRIBUTES, pipeline_id],
    queryFn: () => getOpportunityAttributesByPipelineId(pipeline_id),
    retry: 1,
    refetchOnMount: false,
    enabled: enabled && !!pipeline_id,
    refetchOnWindowFocus: false,
  });

  return { opportunityAttributes, loadingOpportunityAttributes };
};

export const useInvalidateOpportunityAttributes = () => {
  const queryClient = useQueryClient();

  const invalidateOpportunityAttributes = (view_id?: string) => {
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEY.OPPORTUNITY_ATTRIBUTES, view_id],
    });
  };

  return { invalidateOpportunityAttributes };
};
